type PinProps = {
  width?: number;
  height?: number;
};

export default function Pin(props: PinProps) {
  return (
    <svg
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.742 17.3727C12.1691 16.6285 16.9361 13.791 16.9361 9.09305C16.9361 5.45181 13.9843 2.5 10.3431 2.5C6.70181 2.5 3.75 5.45181 3.75 9.09305C3.75 13.791 8.51701 16.6285 9.94411 17.3727C10.1967 17.5044 10.4894 17.5044 10.742 17.3727ZM10.3432 11.9186C11.9037 11.9186 13.1688 10.6536 13.1688 9.09305C13.1688 7.53252 11.9037 6.26746 10.3432 6.26746C8.78264 6.26746 7.51757 7.53252 7.51757 9.09305C7.51757 10.6536 8.78264 11.9186 10.3432 11.9186Z"
        fill="#F27021"
      />
      <path
        d="M10.742 17.3727L10.4646 16.8407L10.742 17.3727ZM9.94411 17.3727L10.2215 16.8407L9.94411 17.3727ZM16.3361 9.09305C16.3361 11.2258 15.2557 12.9669 13.947 14.2943C12.6386 15.6213 11.1511 16.4827 10.4646 16.8407L11.0194 17.9047C11.76 17.5185 13.3696 16.5891 14.8015 15.1368C16.233 13.6849 17.5361 11.6582 17.5361 9.09305H16.3361ZM10.3431 3.1C13.6529 3.1 16.3361 5.78318 16.3361 9.09305H17.5361C17.5361 5.12044 14.3157 1.9 10.3431 1.9V3.1ZM4.35 9.09305C4.35 5.78318 7.03318 3.1 10.3431 3.1V1.9C6.37044 1.9 3.15 5.12044 3.15 9.09305H4.35ZM10.2215 16.8407C9.53504 16.4827 8.04752 15.6213 6.73914 14.2943C5.43038 12.9669 4.35 11.2258 4.35 9.09305H3.15C3.15 11.6582 4.45312 13.6849 5.88464 15.1368C7.31655 16.5891 8.92608 17.5185 9.66668 17.9047L10.2215 16.8407ZM10.4646 16.8407C10.3858 16.8817 10.3003 16.8817 10.2215 16.8407L9.66668 17.9047C10.0931 18.1271 10.593 18.1271 11.0194 17.9047L10.4646 16.8407ZM12.5688 9.09305C12.5688 10.3222 11.5723 11.3186 10.3432 11.3186V12.5186C12.2351 12.5186 13.7688 10.985 13.7688 9.09305H12.5688ZM10.3432 6.86746C11.5723 6.86746 12.5688 7.86389 12.5688 9.09305H13.7688C13.7688 7.20115 12.2351 5.66746 10.3432 5.66746V6.86746ZM8.11757 9.09305C8.11757 7.86389 9.11401 6.86746 10.3432 6.86746V5.66746C8.45126 5.66746 6.91757 7.20115 6.91757 9.09305H8.11757ZM10.3432 11.3186C9.11401 11.3186 8.11757 10.3222 8.11757 9.09305H6.91757C6.91757 10.985 8.45126 12.5186 10.3432 12.5186V11.3186Z"
        fill="#F27021"
      />
    </svg>
  );
}
